import React, {useState} from 'react'
import {Button} from 'react-bootstrap'
import toast from 'react-hot-toast'
import ExcelJS from 'exceljs'

import {validateFleetDataForExport} from './validateData'
import {generateStudentAttendanceWorksheet} from './worksheetGenerator'
import {saveWorkbookAsExcel} from '../../../helpers/saveWorkbook'
import {autoSizeColumns} from '../../../helpers/autoSizeColumns'
import {eachDayOfInterval, getDate, parseISO} from 'date-fns'

interface ExportToExcelProps {
  data: Array<Record<string, any>>
  fileName?: string
  heading?: string
  dateRange: string[]
}

const ExportToExcelButton: React.FC<ExportToExcelProps> = ({
  data,
  fileName = 'ExportedData',
  heading,
  dateRange,
}) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (!validateFleetDataForExport(data)) {
      toast.error('No data to export!')
      return
    }

    try {
      // Convert to Date objects (assumes ISO strings)
      const fromDate = parseISO(dateRange[0])
      const toDate = parseISO(dateRange[1])

      // Get list of days as numbers
      const dayList = eachDayOfInterval({start: fromDate, end: toDate}).map(getDate)
      console.log(dayList)
      setIsExporting(true)
      const workbook = new ExcelJS.Workbook()
      const worksheet = generateStudentAttendanceWorksheet(workbook, data, dayList, heading!)

      autoSizeColumns(worksheet)

      await saveWorkbookAsExcel(workbook, fileName)
    } catch (err) {
      console.error('Export error:', err)
      toast.error('Failed to export data.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button onClick={handleExport} disabled={isExporting} size="sm">
      <div className="flex items-center gap-2">
        Download{' '}
        {isExporting ? (
          <i className="bi bi-arrow-repeat spinner-border spinner-border-sm me-1" />
        ) : (
          <i className="bi bi-download fs-5" />
        )}
      </div>
    </Button>
  )
}

export default ExportToExcelButton
